import { Component, OnInit, Input, booleanAttribute } from '@angular/core';
import { SUMMARY_CHIP_CLASSES, SUMMARY_CHIP_SELECTED_CLASSES } from 'app/core-lib/directives/summary-chip.directive';

@Component({
    selector: 'mh-core-lib-followup-onsite-widget',
    templateUrl: './followup-onsite-widgets.component.html',
    styleUrls: ['./followup-onsite-widgets.component.scss'],
    standalone: false
})
export class CoreLibFollowupOnsiteWidgetsComponent implements OnInit {

  @Input()
  title = '';

  @Input()
  className = '';

  @Input()
  articleClassName = '';

  @Input()
  heightClass = 'tw-h-52';

  @Input()
  tooltip = '';

  /**
   * Estilo plano de chip de resumen (CO-975), el mismo de la directiva `mhSummaryChip`.
   * Sin él la tarjeta conserva la sombra `tw-shadow-1`.
   * Se usa como atributo suelto (`<mh-core-lib-followup-onsite-widget flat>`): `booleanAttribute` convierte
   * el `''` del atributo en `true`.
   */
  @Input({ transform: booleanAttribute })
  flat = false;

  /** Chip plano que actúa como toggle activo (p. ej. "Excluidas"): borde azul de 2 px. */
  @Input({ transform: booleanAttribute })
  selected = false;

  get surfaceClass(): string {
    if (!this.flat) {
      return 'tw-shadow-1';
    }
    return this.selected ? `${SUMMARY_CHIP_CLASSES} ${SUMMARY_CHIP_SELECTED_CLASSES}` : SUMMARY_CHIP_CLASSES;
  }

  constructor() { }

  ngOnInit(): void {
  }

}
